import { render, staticRenderFns } from "./transparent-image.vue?vue&type=template&id=011f017f"
import script from "./transparent-image.vue?vue&type=script&lang=js"
export * from "./transparent-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports